import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  template: `
    <h2 mat-dialog-title class="confirm-title">Confirmação</h2>
    <mat-dialog-content class="confirm-content">
      Tem certeza que deseja prosseguir?
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button class="cancel-button" (click)="onCancel()">Cancelar</button>
      <button mat-raised-button color="primary" class="confirm-button" (click)="onConfirm()">Confirmar</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .confirm-title {
      font-size: 20px;
      font-weight: bold;
      color: #333;
      margin-bottom: 10px;
    }

    .confirm-content {
      font-size: 16px;
      color: #666;
      padding-bottom: 20px;
    }

    mat-dialog-actions {
      display: flex;
      justify-content: flex-end;

      button {
        margin-left: 8px;
        padding: 8px 16px;
      }

      .cancel-button {
        color: #757575;
      }

      .confirm-button {
        background-color: #4caf50;
        color: white;
      }
    }

    @media (max-width: 768px) {
      .confirm-title {
        font-size: 18px;
      }

      .confirm-content {
        font-size: 14px;
      }

      button {
        padding: 6px 12px;
      }
    }
  `],
  imports: [MatDialogModule, MatButtonModule]
})
export class ConfirmDialogComponent {
  constructor(private dialogRef: MatDialogRef<ConfirmDialogComponent>) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}